// extracted by mini-css-extract-plugin
export default {"fileAttachmentList":"fileAttachmentList--zfMSp","uploadButton":"uploadButton--Qla3D"};